/*
 * App Router version of `../getOrderHandler`.
 *
 * Same flow and the same business rules, answering with a `NextResponse`
 * instead of writing to a pages-router `res`, so `get-order` no longer needs
 * `withPagesApiCompat`. The pages folder is left in place and still working
 * for the storefronts that have not moved over yet.
 */
import { NextResponse, type NextRequest } from 'next/server'
import { setRequestLocale } from '../../../common/api/setRequestLocale'
import { routeHandlerWithLogging } from '../../../logging/routeHandlerWithLogging'
import { GET_ORDER_ADAPTERS } from './providers'
import { runGetOrder } from './runGetOrder'
import { type GetOrderHandlerOpts } from './types'

export const getOrderRouteHandler = (opts?: GetOrderHandlerOpts) =>
  routeHandlerWithLogging(async function GET(request: NextRequest) {
    setRequestLocale(request)

    const providerName = opts?.paymentProviderConfig?.providerName ?? 'KLARNA'
    const adapter = GET_ORDER_ADAPTERS[providerName]

    if (!adapter) {
      // todo: add LEDYER
      return NextResponse.json(
        { error: `Not implemented yet: "${providerName}" case` },
        { status: 400 }
      )
    }

    try {
      return await runGetOrder(request, adapter)
    } catch (e) {
      return NextResponse.json(
        { error: e instanceof Error ? e.message : 'Unknown error' },
        { status: 400 }
      )
    }
  })
